import { render, staticRenderFns } from "./RooofAccountTable.vue?vue&type=template&id=bf05f3f4&scoped=true&"
import script from "./RooofAccountTable.vue?vue&type=script&lang=js&"
export * from "./RooofAccountTable.vue?vue&type=script&lang=js&"
import style0 from "./RooofAccountTable.vue?vue&type=style&index=0&id=bf05f3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf05f3f4",
  null
  
)

export default component.exports